import { Routes } from '@angular/router';
import { LoginGuard } from 'src/shared/guards/login.guard';

export const PrescriptionsRoutes: Routes = [
  {
    path: 'prescriptions',
    canActivate: [LoginGuard],
    loadComponent: () => import('./pages/prescriptions/prescriptions.component').then((m) => m.PrescriptionsComponent),
    children: [
      { path: '', redirectTo: 'medication', pathMatch: 'full' },
      {
        path: 'medication',
        loadComponent: () =>
          import('./pages/prescription-list/prescription-list.component').then((m) => m.PrescriptionListComponent),
      },
      {
        path: 'diet',
        loadComponent: () =>
          import('./pages/prescription-list/prescription-list.component').then((m) => m.PrescriptionListComponent),
      },
    ],
  },
];
